import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Radio from '@material-ui/core/Radio';

import { generateID } from 'utils/helpers';


const IDS = {
  prefix: 'k8WnWGun',
  element: 'StyledRadio',
};
const makeId = generateID(IDS.prefix, IDS.element);

function StyledRadio(props) {
  const { radioColor, id, ...rest } = props;

  const classes = makeStyles({ root: { color: radioColor } })();

  return (
    <Radio
      className={classes.root}
      id={makeId(id)}
      {...rest}
    />
  );
}

StyledRadio.propTypes = {
  color: PropTypes.string,
  disableRipple: PropTypes.bool,
  id: PropTypes.string,
  radioColor: PropTypes.string,
};

StyledRadio.defaultProps = {
  color: 'default',
  disableRipple: true,
  id: undefined,
  radioColor: '#60aac6',
};

export default StyledRadio;
